const MIN_USERNAME_LENGTH = 3;
export const MIN_UPDATE_USERNAME_LENGTH = 5;
const MAX_USERNAME_LENGTH = 32;
const USERNAME_REGEX = /^[a-zA-Z]\w+$/;

export function isUsernameValid(username: string, isUpdating?: boolean) {
  const minUsernameLength = isUpdating ? MIN_UPDATE_USERNAME_LENGTH : MIN_USERNAME_LENGTH;
  return username.length >= minUsernameLength
    && username.length <= MAX_USERNAME_LENGTH
    && USERNAME_REGEX.test(username);
}
